export const bufferToBase64 = buffer => btoa(String.fromCharCode(...new Uint8Array(buffer))); // eslint-disable-line no-undef

export const base64ToBuffer = base64 => {
	if (typeof base64 === 'string') {
		return Uint8Array.from(atob(base64), c => c.charCodeAt(0)); // eslint-disable-line no-undef
	}
	return base64;
};

export const decodeBase64 = base64 => atob(base64); // eslint-disable-line no-undef

export const encodeToBase64 = string => btoa(string); // eslint-disable-line no-undef
